import { ComponentType, useEffect, useState } from 'react';
import debounce from '../../utils/debounce';

type ExtendedProps = {
    mobile: boolean;
};

const WithMobileSize = <T extends ExtendedProps>(WrappedComponent: ComponentType<T>, breakpoint = 767) =>
    // named function here because react thrown an exception that hooks can be used only within function messages, syntax with anonympoys () => did not work
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function Component(props: any) {
        const isMobile = () => window.innerWidth < breakpoint;
        const [mobile, setMobile] = useState(isMobile());
        const extendedProps = {
            ...props,
            mobile
        };

        const observeScreenWidth = () => {
            const beforeResizeMode = mobile;
            const currentMode = isMobile();

            if (beforeResizeMode !== currentMode) {
                setMobile(currentMode);
            }
        };

        useEffect(() => {
            const resizer = debounce(observeScreenWidth);

            window.addEventListener('resize', resizer);

            return () => {
                window.removeEventListener('resize', resizer);
            };
        }, [mobile]);

        return <WrappedComponent {...(extendedProps as T)} />;
    };

export default WithMobileSize;
